import { motion } from "framer-motion";

export const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease, delay }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, dark = false }) => (
  <span className={`inline-flex items-center gap-3 font-mono text-xs uppercase tracking-[0.22em] ${dark ? "text-[#0A0E3F]/70" : "text-white/70"}`}>
    <span className="w-8 h-px bg-[#FF6A13]" />
    {children}
  </span>
);

let lenisRef = null;
export const setLenis = (l) => { lenisRef = l; };
export const scrollToId = (e, id) => {
  e.preventDefault();
  const el = document.getElementById(id);
  if (!el) return;
  if (lenisRef) lenisRef.scrollTo(el, { offset: -70, duration: 1.6 });
  else el.scrollIntoView({ behavior: "smooth" });
};
